var _polygon, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-skip-forward",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5 4 15 12 5 20 5 4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    x2: 19,
    y1: 5,
    y2: 19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic_next.46e06096800e8360f48fb9ad38bd42f6.svg";
export { ForwardRef as ReactComponent };